import React from 'react';

import { Box } from '@mui/material';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import './activity-log.scss';
import Typography from '../typography/typography';
import dayjs from 'dayjs';
import formatText from '../../utils/format-text';
import { useTranslation } from 'react-i18next';

export const ActivityTag = (props: any) => {
	const { t } = useTranslation();
	const { data } = props;

	const formatDateTime = (date: Date): string => {
		const formattedDate = dayjs(date).format('DD MMM, YYYY');
		const formattedTime = dayjs(date).format('HH:mm');
		return `${formattedDate} • ${formattedTime}`;
	};

	const actions = {
		view: t('common.viewed_text'),
		delete: t('common.deleted_text'),
		create: t('common.created_text'),
		update: t('common.updated_text')
	};
	return (
		// <Box position='relative'>
		<Box>
			<Timeline className='Timeline'>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						gap: 2,
						padding: '16px'
					}}
					className='box-class'>
					<Typography type='s3' weight='medium' color='theme.secondary.800'>
						{t('common.activities_label')}
					</Typography>
					<Box
						sx={{
							height: 400,
							overflowY: 'auto',
							gap: 1.5,
							display: 'flex',
							flexDirection: 'column'
						}}>
						{data?.map((item: any, index: number) => (
							<div className='Timeline--Activity'>
								<TimelineItem key={index}>
									<TimelineSeparator>
										<TimelineDot
											color='primary'
											sx={{ backgroundColor: '#D3D3D4' }}
										/>
										{data.length - 1 !== index && <TimelineConnector />}
									</TimelineSeparator>
									<TimelineContent className='Timeline--Content'>
										<Typography
											type='s5'
											color='theme.secondary.800'
											className='Timeline--ActivityLogItem'>
											<b>{formatText(item.username)}</b> {actions[item.action]}{' '}
											<b>{formatText(item.resource?.replace('_', ' '))}</b>
										</Typography>
										<Typography
											type='s5'
											color='theme.secondary.800'
											className='Timeline--ActivityLogItem'>
											{formatDateTime(item?.created_at)}
										</Typography>
									</TimelineContent>
								</TimelineItem>
							</div>
						))}
					</Box>
				</Box>
			</Timeline>
		</Box>
		// </Box>
	);
};

export default ActivityTag;
